<template>
  <div class="customer-status-display">
    <v-alert
      v-if="customer.status === 'active'"
      type="success"
      text
      border="left"
      class="mb-0"
    >
      <div class="d-flex align-center">
        <customer-status-badge :status="customer.status" class="mr-3" />
        <span>{{ $t('customer.status-active-description') }}</span>
      </div>
    </v-alert>

    <v-alert
      v-else-if="customer.status === 'suspended-admin'"
      type="warning"
      text
      border="left"
      class="mb-0"
    >
      <div class="mb-2">
        <customer-status-badge :status="customer.status" class="mr-3" />
      </div>
      <div><strong>{{ $t('customer.suspended-at') }}:</strong> {{ formatDate(customer.suspendedAt) }}</div>
      <div v-if="customer.suspendedBy">
        <strong>{{ $t('customer.suspended-by') }}:</strong> {{ customer.suspendedBy.firstname }} {{ customer.suspendedBy.lastname }}
      </div>
      <div v-if="customer.suspendedReason" class="mt-2">
        <strong>{{ $t('customer.suspension-reason') }}:</strong> {{ customer.suspendedReason }}
      </div>
    </v-alert>

    <v-alert
      v-else-if="customer.status === 'pending-deletion'"
      type="error"
      text
      border="left"
      class="mb-0"
    >
      <div class="d-flex align-center mb-3">
        <customer-status-badge :status="customer.status" class="mr-3" />
        <div class="error--text font-weight-bold">
          <v-icon small color="error" class="mr-1">mdi-alert</v-icon>
          {{ $t('customer.deletion-in-days', {days: daysUntilDeletion}) }}
        </div>
      </div>

      <div class="grey--text text--darken-1 text-body-2">
        {{ $t('customer.deletion-scheduled-for') }}: <strong>{{ formatDate(deletionDate) }}</strong>
      </div>

      <div v-if="customer.deletionReason" class="mt-2 grey--text text--darken-1 text-body-2">
        {{ customer.deletionReason }}
      </div>
    </v-alert>

    <v-alert
      v-else-if="customer.status === 'deleted'"
      type="error"
      text
      border="left"
      class="mb-0"
    >
      <div class="mb-2">
        <customer-status-badge :status="customer.status" class="mr-3" />
      </div>
      <div><strong>{{ $t('customer.deleted-at') }}:</strong> {{ formatDate(customer.deletedAt) }}</div>
    </v-alert>

    <v-alert
      v-else-if="customer.status === 'pending-verification'"
      type="info"
      text
      border="left"
      class="mb-0"
    >
      <div class="d-flex align-center">
        <customer-status-badge :status="customer.status" class="mr-3" />
        <span>{{ $t('customer.status-pending-verification-description') }}</span>
      </div>
    </v-alert>
  </div>
</template>

<script>
import CustomerStatusBadge from "@/components/blocks/CustomerStatusBadge.vue";

export default {
  name: 'CustomerStatusDisplay',

  components: {
    CustomerStatusBadge
  },

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  computed: {
    deletionDate() {
      return this.customer.deletionScheduledAt || null
    },

    daysUntilDeletion() {
      if (!this.customer.deletionScheduledAt) return 0
      const now = new Date()
      const deletionScheduledAt = new Date(this.customer.deletionScheduledAt)
      const diffTime = deletionScheduledAt - now
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return Math.max(0, diffDays)
    }
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString(this.$i18n.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-status-display {
  width: 100%;
}
</style>